<template>
    <div class="gpt-viewer-pdf">
        <embed v-if="url" :src="url" controls width="100%" height="100%" type="application/pdf" />
    </div>
</template>

<script>
export default {
    name: 'gpt-viewer-pdf',
    data () {
        return {};
    },
    props: {
        url: {
            type: String,
            default: null
        }
    },
    watch: {
        url () {
        }
    },
    mounted () {
    },
    methods: {
        load () {

        }
    }
};
</script>
<style scoped lang="scss">
.gpt-viewer-pdf {
    position: relative;
    width: 100%;
    height: 100%;
}
</style>
